import { SelectAll } from "@mui/icons-material";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const storedLanguage = localStorage.getItem("preferredLanguage");

const resources = {
  en: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        FileTransferHistory: "File Transfer History",
        Transfer: "Transfer",
        //
        UploadFile: "Upload File",
        reqUser: "User is required",
        reqGender: "Gender is required",
        reqcountryName: "Country is required",
        zoneName: "Zone Name",
        reqMenuName: "Menu Name is required",
        CreateMenuMaster: "Create Menu Master",
        EditMenuMaster: "Edit Menu Master",
        EnterMenuName: "Enter Menu Name",
        EnterPageURL: "Enter Page URL",
        EnterIcon: "Enter Icon",
        selectParentMenuName: "Select Parent Menu Name",
        EnterdisplayNo: "Enter Display No.",
        saving: "saving",
        reqfileNo: "File No. is required",
        reqJurisdiction: "Jurisdiction is required",
        SelectLocation: "Select Location",
        NoFileContentAvailable: "File Content Not Available",
        PreviewFile: "File Preview",
        NoDataToExport: "No Data To Export",
        PDFPreview: "PDF Preview",
        Cancel: "Cancel",
        Download: "Download",
        ChakNo: "Chak No",
        ApplicationNo: "Application No",
        SelectStatus: "Select Status",
        RequestForm: "Request Form",
        Excel: "Excel",
        PDF: "PDF",
        AssignedFiles: "Assigned Files",
        CreatedFiles: "Created Files",
        AuditTrailDetail: "Audit Trail Detail",
        FileName: "File Name",
        FileNumber: "File Number",
        NA: "N/A",
        TransferDetails: "Transfer Details",
        FromLocation: "From Location",
        ToLocation: "To Location",
        NotSpecified: "Not specified",
        Through: "Through",
        DirectTransfer: "Direct transfer",
        Personnel: "Personnel",
        Sender: "Sender",
        Receiver: "Receiver",
        InitiatedBy: "Initiated By",
        System: "System",
        Timeline: "Timeline",
        FileDate: "File Date",
        CreatedDate: "Created Date",
        ReceivedDate: "Received Date",
        TransferDate: "Transfer Date",
        NotTransferredYet: "Not transferred yet",
        Close: "Close",

        FileMovementDetails: "File Movement Details",
        FileName: "File Name",
        FileNumber: "File Number",
        NA: "N/A",
        TransferDetails: "Transfer Details",
        FromLocation: "From Location",
        ToLocation: "To Location",
        NotSpecified: "Not specified",
        Through: "Through",
        DirectTransfer: "Direct transfer",
        Personnel: "Personnel",
        Sender: "Sender",
        Receiver: "Receiver",
        InitiatedBy: "Initiated By",
        System: "System",
        Timeline: "Timeline",
        FileDate: "File Date",
        CreatedDate: "Created Date",
        ReceivedDate: "Received Date",
        TransferDate: "Transfer Date",
        NotTransferredYet: "Not transferred yet",
        Close: "Close",

        Nodatafoundfortheselectedfilters:
          "No data found for the selected filters",
        Pleaseapplyfiltersandclicksearchtoviewdata:
          "Please apply filters and click search to view data",
        FileName: "File Name",
        FileDetails: "File Details",
        FileNo: "File No",
        RFID: "RFID",
        BasicInformation: "Basic Information",
        FileType: "File Type",
        FileGroup: "File Group",
        Category: "Category",
        Class: "Class",
        Subject: "Subject",
        chackNo: "Chak No",
        TotalPages: "Total Pages",
        PagesRange: "Pages Range",
        StatusLocation: "Status & Location",
        Status: "Status",
        Received: "Received",
        Pending: "Pending",
        Forwarded: "Forwarded",
        NA: "N/A",
        CurrentLocation: "Current Location",
        Zone: "Zone",
        Ward: "Ward",
        Registrar: "Registrar",
        DatesTracking: "Dates & Tracking",
        CreatedDate: "Created Date",
        UpdatedDate: "Updated Date",
        ProposalNo: "Proposal No",
        ProposalDate: "Proposal Date",
        AdditionalInformation: "Additional Information",
        Synopsis: "Synopsis",
        Remark: "Remark",
        NoRemarksProvided: "No remarks provided",
        Close: "Close",
        AuditTrailReport: "Audit Trail Report",
        PanchShala: "PanchShala",
        // Dashboard
        TotalFile: " Total File",
        TotalEPCApproved: "Total EPC Approved",
        TotalEPCPending: "Total EPC Pending",
        TotalFileIssue: "Total File Issue",
        Zone: "Zone",
        WardData: "Ward Data",
        PleaseSelectZonetoCheckWardList:
          "Please Select Zone to Check Ward List",
        NoticeBoard: "Notice Board",
        wardlist: "Ward List",
        selectAll: "Select All",
        zoneMaster: "Zone Master",
        add: "ADD",
        print: "Print",
        Active: "Active",
        InActive: "InActive",
        Action: "Action",
        SrNo: "Sr No.",

        zoneCode: "Zone Code",
        Status: "Status",
        search: "Search",
        save: "Save",
        reset: "Reset",
        EnterFileName: "Enter File Name",
        Synopsis: "Synopsis",
        EnterFileNo: "Enter File Number",
        EnterchackNo: "Enter Chak Number",
        TotalPage: "Total Page",
        FromPage: "From Page",
        ToPage: "To Page",
        EnterStatus: "Enter Status",
        EnterRFID: "Enter RFID",
        SelectFileType: "Select File Type",
        SelectFileGroup: "Select File Group",
        SelectFileCategory: "Select File Category",
        SelectFileClass: "Select File Class",
        SelectFileSubject: "Select File Subject",
        senderID: "Sender",
        receiverID: "Receiver",
        currentLocation: "Current Location",
        EnterRemark: "Enter Remark",
        EnterDocUpload: "Doc Upload",
        FileDetailsAdd: "File Details Add",
        Preview: "Preview",
        FileDetailsEdit: "File Details Edit",
        FileDetails: "File Details",
        FileName: "File Name",
        FileNo: "File Number",
        chackNo: "Chak Number",
        Add: "Add",
        DoYouWantToDeleteThisRecord: "Do You Want To Delete This Record ?",
        DeleteConfirmation: "Delete Confirmation",
        AssignLocation: "Assign Location",
        EPCDelete: "EPC Delete",
        AssignBook: "Assign File",
        GetEpc: "Get Epc",
        EnterToPage: "Enter To Page",
        EnterFromPage: "Enter From Page",
        EnterTotalPage: "Enter Total Page",
        AttachedFile: "Attache File",
        EnterSynopsis: "Enter Synopsis",
        EpcNumber: "Epc Number",
        selectfiledetails: "select File Details",
        selectMapLoc: "Select Map Location",
        SelectSenderMember: "Select Sender ",
        SelectReceiverMember: "Select Receiver ",
        FileMovement: "File Movement",
        RFID: "RFID",
        Remark: "Remark",
        UserFileMovement: "User File Movement",
        FromLocation: "From Location",
        ToLocation: "To Location",
        SenderName: "Sender Name",
        ReceiverName: "Receiver Name",
        Send: "Send",
        Receive: "Receive",
        ReceivedDate: "Received Date",
        FileDate: "File Date",
        CreateEmployeeRegistration: "Create Employee Registration",
        EnterEmployeeName: "Enter Employee Name",
        EnterEmployeeCode: "Enter Employee Code",
        EnterFatherName: "Enter Father Name",
        EnterMotherName: "Enter Mother Name",
        EnterSpauseName: "Enter Spause Name",
        EnterMobileNo: "Enter Mobile Number",
        EnterEmail: "Enter Email",
        EnterPanNo: "Enter Pan No.",
        EnterAdharNumber: "Enter Adhar Number",
        EnterDOB: "Enter D.O.B",
        EnterJoiningDate: "Enter Joining Date",
        EnterRetirementDate: "Enter Retirement Date",
        DobRequired: "D.O.B Required",
        EmpNameRequired: "Employee Name Required",
        EmpCodeRequired: "Employee Code Required",
        FatherNameRequired: "Father Name Required",
        MobNoRequired: "Mobile Number Required",
        reqMail: "Email Required",
        AdharNoRequired: "Adhar Number Required",
        PanNoRequired: "Pan Number Required",
        JoiningDateRequired: "Joining Date Required",
        PermanentAddressRequired: "Permanent Address Required",
        PincodeRequired: "Pin Code Required",
        SelectDepartment: "Select Department",
        SelectDesignation: "Select Designation",
        SelectCountry: "Select Country",
        SelectCity: "Select City",
        SelectState: "Select State",
        SelectRole: "Select Role",
        SelectGender: "Select Gender",
        EnterLocalAddress: "Enter Local Address",
        EnterPermanentAddress: "Enter Permanent Address",
        EnterPincode: "Enter PinCode",
        AttachedImage: "Attach Image",
        AttachedSignature: "Attach Signature",
        EditEmployeeRegistration: "Edit Employee Registration",
        EmpMaster: "Employee Master",
        EmpName: "Employee Name",
        EmpCode: "Employee Code",
        EmpStatus: "Employee Status",
        createZoneMaster: "Create Zone Master",
        enterZoneName: "Enter Zone Name",
        enterZoneCode: "Enter Zone Code",
        editZoneMaster: "Edit Zone Master",
        zoneMaster: "Zone Master",
        wardMaster: "Ward Master",
        wardName: "Ward Name",
        wardCode: "Ward No.",
        SelectZoneName: "Select Zone Name",
        enterWardName: "Enter Ward Name",
        enterWardCode: "Enter Ward No.",
        createWardMaster: "Create Ward Master",
        SelectZone: "Select Zone",
        editWardMaster: "Edit Ward Master",
        CountryMaster: "Country Master",
        CountryName: "Country Name",
        CountryCode: "Country Code",
        Nationality: "Nationality",
        EnterCountryName: "Enter Country Name",
        EnterCountryCode: "Enter Country Code",
        EnterNationality: "Enter Nationality",
        CreateCountryName: "Create Country Name",
        EditCountryMaster: "Edit Country Master",
        StateMaster: "State Master",
        StateName: "State Name",
        StateCode: "State Code",
        SelectCountryName: "Select Country Name",
        CreateStateMaster: "Create State Master",
        EnterStateName: "Enter State Name",
        EnterStateCode: "Enter State Code",
        EnterCountryName: "Enter Country Name",
        EditStateMaster: "Edit State Master",
        DistrictMaster: "District Master",
        DistrictName: "District Name",
        CreateDistrictMaster: "Create District Master",
        SelectStateName: "Select State Name",
        EnterDistrictName: "Enter District Name",
        EditDistrictMaster: "Edit District Master",
        GenderMaster: "Gender Master",
        GenderName: "Gender Name",
        GenderCode: "Gender Code",
        CreateGenderMaster: "Create Gender Master",
        EnterGenderName: "Enter Gender Name",
        EnterGenderCode: "Enter Gender Code",
        EditGenderMaster: "Edit Gender Master",
        WeedingOutAuthority: "Weeding Out Authority",
        ClassDescription: "Class Description",
        ShortName: "Short Name",
        FileClass: "File Class",
        CreateFileClass: "Create File Class",
        EnterClassDescription: "Enter Class Description",
        EnterWeedingOutAuthority: "Enter Weeding Out Authority",
        EnterShortName: "Enter Short Name",
        EditFileClass: "Edit File Class",
        FileGroup: "File Group",
        EnterFileGroupName: "Enter File Group Name",
        FileGroupName: "File Group Name",
        reqFileGroupName: "File Group Name Require",
        FileSubject: "File Subject",
        EnterFileSubjectName: "Enter File Subject Name",
        FileSubjectName: "File Subject Name",
        FileType: "File Type",
        EnterFileTypeName: "Enter File Type Name",
        FileTypeName: "File Type Name",
        update: "UPDATE",
        classDescription: "class Description",
        ReqclassDescription: "Require class Description",
        LocationObjectItems: "Location Object Items",
        Mapping: "Mapping",
        selectParntLoc: "select Parent Location",
        selectLoc: "select Location",
        enterAddItem: "Enter Add Item",
        enterAlias: "Enter Alias",
        enterFrom: "Enter From",
        enterTo: "Enter To",
        generate: "Generate",
        LocationItem: "Location Item",
        MappedLocation: "Mapped Location",
        Mapped: "Mapped",
        Unmapped: "Unmapped",
        reqdAlias: "Alias Is Require",
        LocationName: "Location Name",
        selectAll: "Select All",
        UpdateMapped: "Update Mapped",
        LocationPath: "Location Path",
        Location: "Location",
        ReceiptStatus: "Receipt Status",
        RecStatus: "Receipt Status",
        EnterRecStatus: "Enter Receipt Status",
        ReceiptType: "Receipt Type",
        ReceiptName: "Receipt Name",
        EnterReceiptName: "Enter Receipt Name",
        FileCategory: "File Category",
        FileCatDescription: "File Category Description",
        FileCatDescRequired: "File Category Description Required",
        CreateFileCategory: "Create File Category",
        EditFileCategory: "Edit File Category",
        EnterFileCategory: "Enter File Category",
        JurisdictionName: "Jurisdiction Name",
        JurisdictionMaster: "Jurisdiction Master",
        CreateJurisdictionMaster: "Create Jurisdiction Master",
        EditJurisdictionMaster: "Edit Jurisdiction Master",
        EnterJurisdictionName: "Enter Jurisdiction Name",
        SelectNode: "Select Node",
        RoleMaster: "Role Master",
        RoleName: "Role Name",
        reqRoleName: "Role Name Is Require",
        enterRoleName: "Enter Role Name",
        search: "Search",
        MenuName: "Menu Name",
        Edit: "Edit",
        delete: "Delete",
        View: "View",
        Print: "Print",
        Export: "Export",
        Release: "Release",
        Post: "Post",
        UserPermissionMaster: "User Permission Master",
        UserName: "User Name",
        SelectEmployeeName: "Select Employee Name",
        ParentName: "Parent Name",
        FileDetailsAddedSuccessFully: "File Details Added SuccessFully",
        FileDetailsUpdatedSuccessFully: "File Details Updated SuccessFully",
        LoginName: "Login Name",
        Email: "Email",
        Role: "Role",
        UserManegment: "User Management",
        DOB: "Date Of Birth",
        CreateUserManegment: "Create User Management",
        EnterFirstName: "Enter Frist Name",
        EnterLastName: "Enter Last Name",
        EnterMiddleName: "Enter Middle Name",
        EnterLoginName: "Enter Login Name",
        EnterPassword: "Enter Password",
        EnterUserCode: "Enter User Code",
        EnterEmailId: "Enter Email Id",
        EnterDateOfBirth: "Enter Date Of Birth",
        reqFirst: "First Name Is Require",
        reqLast: "Last Name Is Require",
        reqLogin: "Login Name Is Require",
        reqPassword: "Password is Require",
        reqMobile: "Mobile Number Is Require",
        reqEmail: "Email Is Require",
        reqDate: "Date Of Birth Is Require ",
        SelectUserType: "Select User Type",
        SelectEmployee: "Select Employee",
        Name: "Name",
        UserTypeMaster: "User Type Master",
        EnterUserType: "Enter User Type",
        UserType: "User Type",
        FileDetailsReport: "File Details Report",
        SelectFile: "Select File",
        Selectchack: "Select Chak",
        Filter: "Filter",
        Clear: "Reset",
        FileMovementReport: "File Movement Report",
        Sender: "Sender",
        Receiver: "Receiver",
        reqZoneName: "Zone Name Is Required",
        reqWard: "Ward Name Is Require",
        reqstateName: "State Name Is Require",
        reqdistrictName: "District Name Is Required",
        reqGenderName: "Gender Name Is Require",
        reqFileSubjectName: "File Subject Name Is Require",
        reqFileTypeName: "File Type Is Require",
        reqRecStatus: "Receipt Status Is Require",
        reqReceiptName: "Receipt Name Is Require",
        reqUserType: "User Type Is Require",
        reqFileName: "File Name Is Require",
        reqchackNo: "Chak Number Is Require",
        SelectRFID: "Select RFID",
        SelectFromLocation: "Select From Location",
        SelectToLocation: "Select To Location",
        NodePermission: "Node Permission",
        AddPermission: "Add Permission",
        SelectUser: "Select User",
        NodeName: "Node Name",
        throughyby: "Through whom",
        ethroughyby: "Enter Through whom",
        nodeID: "Select Jurisdiction",
        ReqFormAdd: "Request Form Add",
        ReqFormEdit: "Request Form Edit",
        EnterReqDate: "Enter Request Date",
        EnterCustomerName: "Enter Customer Name",
        MobileNO: "Mobile Number",
        HouseNO: "House Number",
        EnterAddress: "Enter Address",
        ReceiptDate: "Receipt Date",
        ReqFileStatus: "Req. File Status",
        chackNo: "Chak Number",
        EditFileMovement: "Edit File Movement",
        RegistrarName: "Registrar Name",
        ProposalNo: "Proposal Number",
        ProposalDate: "Proposal Date",

        NoticeManagement: "Notice Management",
        add: "Add",
        edit: "Edit",
        update: "Update",
        reset: "Reset",
        save: "Save",
        SrNo: "Sr. No",
        Notice: "Notice",
        Description: "Description",
        NoticeDate: "Notice Date",
        FromDate: "From Date",
        ToDate: "To Date",
        NoticeLink: "Notice Link",
        Status: "Status",
        Active: "Active",
        InActive: "Inactive",
        Action: "Action",
        CreateNotice: "Create Notice",
        EditNotice: "Edit Notice",
        NoticeTitle: "Notice Title",
        EnterNoticeTitle: "Enter Notice Title",
        EnterNoticeLink: "Enter Notice Link",
        EnterDescription: "Enter Description",
        UploadImage: "Upload Image",
        PreviewImage: "Preview Image",
        noticeTitleRequired: "Notice title is required",
        descriptionRequired: "Description is required",
        fromDateRequired: "From date is required",
        toDateRequired: "To date is required",
        toDateAfterFromDate: "To date must be after from date",
        validUrl: "Must be a valid URL",
        fileTooLarge: "File too large (max 5MB)",
        unsupportedFormat:
          "Unsupported file format (only jpg, png, gif allowed)",
        existingImage: "Existing Image",
        SelectWardName: "Select Ward Name",
        EnterOwnerName: "Enter Owner Name",
        FailedToFetchPendingData: "Failed to fetch pending data",
        AnUnknownErrorOccurred: "An unknown error occurred",
        FileNo: "File No",
        FileName: "File Name",
        Synopsis: "Synopsis",
        RFID: "RFID",
        ChackNo: "Chack No",
        CurrentLocation: "Current Location",
        PendingEPCData: "Pending EPC Data",
        HideFilters: "Hide Filters",
        ShowFilters: "Show Filters",
        Zone: "Zone",
        Ward: "Ward",
        Reset: "Reset",
        Close: "Close",
        ApprovedEPCData: "Approved EPC Data",
        TotalEPCData: "Total EPC Data",
        WardDetails: "Ward Details",
        WardName: "Ward Name",
        FileCount: "File Count",
        files: "Files",
        EnterChackNo: "Enter Chak No",
        reqChackNo: "Chak No is required",
        SelectChackNo: "Select Chack No",
        MenuMaster: "Menu Master",
        PageURL: "Page URL",
        Icon: "Icon",
      },

      content: {},
    },
  },
  hi: {
    translation: {
      label: {},
      error: {},
      message: {},
      text: {
        PanchShala: "पंचशाला",
        // Dashboard
        TotalFile: "कुल फ़ाइल",
        TotalEPCApproved: "कुल ईपीसी मंजूर",
        TotalEPCPending: "कुल ईपीसी लंबित",
        TotalFileIssue: "टोटल फाइल समस्या",
        Zone: "ज़ोन",
        WardData: "क्षेत्र डेटा",
        PleaseSelectZonetoCheckWardList:
          "कृपया जोन का चयन करें जिसमें आप वार्ड सूची की जाँच करना चाहते हैं।",
        NoticeBoard: "नोटिस बोर्ड",
        wardlist: "वार्ड सूची",
        throughyby: "किसके माध्यम से",
        ethroughyby: "किसके माध्यम से प्रवेश करें",
        nodeID: "क्षेत्राधिकार का चयन करें",
        selectAll: "सबका चयन करें",
        zoneMaster: "ज़ोन मास्टर",
        add: "जोड़ें",
        print: "प्रिंट",
        Active: "सक्रिय",
        InActive: "निष्क्रिय",
        Action: "क्रिया",
        SrNo: "क्रम संख्या",
        zoneName: "जोन का नाम",
        zoneCode: "ज़ोन कोड",
        Status: "स्थिति",
        search: "खोजें",
        save: "सहेजें",
        reset: "रीसेट करें",
        EnterFileName: "फ़ाइल का नाम दर्ज करें",
        Synopsis: "रूपरेखा",
        EnterFileNo: "फ़ाइल नंबर दर्ज करें",
        EnterchackNo: "चक नंबर दर्ज करें",
        TotalPage: "कुल पृष्ठ",
        FromPage: "पेज से",
        ToPage: "पेज के लिए",
        EnterStatus: "स्थिति दर्ज करें",
        EnterRFID: "आरएफआईडी दर्ज करें",
        SelectFileType: "फ़ाइल प्रकार का चयन करें",
        SelectFileGroup: "फ़ाइल समूह का चयन करें",
        SelectFileCategory: "फ़ाइल श्रेणी का चयन करें",
        SelectFileClass: "फ़ाइल वर्ग का चयन करें",
        SelectFileSubject: "फ़ाइल विषय का चयन करें",
        senderID: "प्रेषक",
        receiverID: "रिसीवर",
        currentLocation: "वर्तमान स्थान",
        EnterRemark: "टिप्पणी दर्ज करें",
        EnterDocUpload: "दस्तावेज़ अपलोड",
        FileDetailsAdd: "फ़ाइल विवरण जोड़ें",
        Preview: "पूर्वसमीक्षा",
        FileDetailsEdit: "फ़ाइल विवरण संपादित करें",
        FileDetails: "फ़ाइल विवरण",
        FileName: "फ़ाइल का नाम",
        FileNo: "फ़ाइल संख्या",
        chackNo: "चक नंबर",
        Add: "जोड़ें",
        DoYouWantToDeleteThisRecord: "क्या आप इस रिकॉर्ड को हटाना चाहते हैं ?",
        DeleteConfirmation: "पुष्टिकरण हटाएं",
        AssignLocation: "स्थान असाइन करें",
        EPCDelete: "ईपीसी हटाएं",
        AssignBook: "फ़ाइल असाइन करें",
        GetEpc: "ईपीसी प्राप्त करें",
        EnterToPage: "पृष्ठ पर दर्ज करें",
        EnterFromPage: "पृष्ठ से दर्ज करें",
        EnterTotalPage: "कुल पृष्ठ दर्ज करें",
        AttachedFile: "अटैच फ़ाइल",
        EnterSynopsis: "सारांश दर्ज करें",
        EpcNumber: "ईपीसी नंबर",
        selectfiledetails: "फ़ाइल विवरण का चयन करें",
        selectMapLoc: "मानचित्र स्थान का चयन करें",
        SelectSenderMember: "प्रेषक का चयन करें",
        SelectReceiverMember: "रिसीवर का चयन करें",
        FileMovement: "फ़ाइल आंदोलन",
        RFID: "आरएफआईडी",
        Remark: "टिप्‍पणी करना",
        UserFileMovement: "उपयोगकर्ता फ़ाइल आंदोलन",
        FromLocation: "स्थान से",
        ToLocation: "स्थान के लिए",
        SenderName: "प्रेषक का नाम",
        ReceiverName: "रिसीवर का नाम",
        Send: "भेजना",
        Receive: "प्राप्त करना",
        ReceivedDate: "प्राप्त तिथि",
        FileDate: "फ़ाइल दिनांक",
        CreateEmployeeRegistration: "कर्मचारी पंजीकरण बनाएं",
        EnterEmployeeName: "कर्मचारी का नाम दर्ज करें",
        EnterEmployeeCode: "कर्मचारी कोड दर्ज करें",
        EnterFatherName: "पिता का नाम दर्ज करें",
        EnterMotherName: "माँ का नाम दर्ज करें",
        EnterSpauseName: "स्पाज़ नाम दर्ज करें",
        EnterMobileNo: "मोबाइल नंबर दर्ज करें",
        EnterEmail: "ईमेल दर्ज करें",
        EnterPanNo: "पैन नंबर दर्ज करें",
        EnterAdharNumber: "आधार नंबर दर्ज करें",
        EnterDOB: "जन्म तिथि दर्ज करें",
        EnterJoiningDate: "ज्वाइनिंग डेट दर्ज करें",
        EnterRetirementDate: "सेवानिवृत्ति की तिथि दर्ज करें",
        DobRequired: "जन्म तिथि आवश्यक है",
        EmpNameRequired: "कर्मचारी का नाम आवश्यक है",
        EmpCodeRequired: "कर्मचारी कोड आवश्यक है",
        FatherNameRequired: "पिता का नाम आवश्यक है",
        MobNoRequired: "मोबाइल नंबर आवश्यक है",
        reqMail: "ईमेल आवश्यक है",
        AdharNoRequired: "आधार नंबर जरूरी है",
        PanNoRequired: "पैन नंबर आवश्यक है",
        JoiningDateRequired: "ज्वाइनिंग डेट आवश्यक है",
        PermanentAddressRequired: "स्थायी पता आवश्यक है",
        PincodeRequired: "पिन कोड आवश्यक है",
        SelectDepartment: "विभाग का चयन करें",
        SelectDesignation: "पदनाम का चयन करें",
        SelectCountry: "देश का चयन करें",
        SelectCity: "शहर का चयन करें",
        SelectState: "राज्य का चयन करें",
        SelectRole: "भूमिका का चयन करें",
        SelectGender: "लिंग का चयन करें",
        EnterLocalAddress: "स्थानीय पता दर्ज करें",
        EnterPermanentAddress: "स्थायी पता दर्ज करें",
        EnterPincode: "पिनकोड दर्ज करें",
        AttachedImage: "छवि संलग्न करें",
        AttachedSignature: "हस्ताक्षर संलग्न करें",
        EditEmployeeRegistration: "कर्मचारी पंजीकरण संपादित करें",
        EmpMaster: "कर्मचारी मास्टर",
        EmpName: "कर्मचारी का नाम",
        EmpCode: "कर्मचारी कोड",
        EmpStatus: "कर्मचारी की स्थिति",
        createZoneMaster: "ज़ोन मास्टर बनाएँ",
        enterZoneName: "ज़ोन का नाम दर्ज करें",
        enterZoneCode: "ज़ोन कोड दर्ज करें",
        editZoneMaster: "ज़ोन मास्टर संपादित करें",
        zoneMaster: "ज़ोन मास्टर",
        wardMaster: "वार्ड मास्टर",
        wardName: "वार्ड का नाम",
        wardCode: "वार्ड नं.",
        SelectZoneName: "ज़ोन नाम का चयन करें",
        enterWardName: "वार्ड का नाम दर्ज करें",
        enterWardCode: "वार्ड नं. दर्ज करें",
        createWardMaster: "वार्ड मास्टर बनाएं",
        SelectZone: "क्षेत्र का चयन करें",
        editWardMaster: "वार्ड मास्टर संपादित करें",
        CountryMaster: "कंट्री मास्टर",
        CountryName: "देश का नाम",
        CountryCode: "देश कोड",
        Nationality: "राष्ट्रीयता",
        EnterCountryName: "देश का नाम दर्ज करें",
        EnterCountryCode: "देश कोड दर्ज करें",
        EnterNationality: "राष्ट्रीयता दर्ज करें",
        CreateCountryName: "देश का नाम बनाएं",
        StateMaster: "स्टेट मास्टर",
        StateName: "राज्य का नाम",
        StateCode: "राज्य कोड",
        SelectCountryName: "देश का नाम चुनें",
        CreateStateMaster: "स्टेट मास्टर बनाएं",
        EnterStateName: "राज्य का नाम दर्ज करें",
        EnterStateCode: "राज्य कोड दर्ज करें",
        EnterCountryName: "देश का नाम दर्ज करें",
        EditStateMaster: "राज्य मास्टर संपादित करें",
        DistrictMaster: "जिला मास्टर",
        DistrictName: "जिले का नाम",
        CreateDistrictMaster: "जिला मास्टर बनाएं",
        SelectStateName: "राज्य का नाम चुनें",
        EnterDistrictName: "जिले का नाम दर्ज करें",
        EditDistrictMaster: "संपादित करें जिला मास्टर",
        GenderMaster: "लिंग मास्टर",
        GenderName: "लिंग का नाम",
        GenderCode: "लिंग कोड",
        CreateGenderMaster: "जेंडर मास्टर बनाएं",
        EnterGenderName: "लिंग का नाम दर्ज करें",
        EnterGenderCode: "लिंग कोड दर्ज करें",
        EditGenderMaster: "जेंडर मास्टर संपादित करें",
        WeedingOutAuthority: "प्राधिकरण की निराई",
        ClassDescription: "कक्षा विवरण",
        ShortName: "संक्षिप्त नाम",
        FileClass: "फ़ाइल वर्ग",
        CreateFileClass: "फ़ाइल वर्ग बनाएँ",
        EnterClassDescription: "कक्षा विवरण दर्ज करें",
        EnterWeedingOutAuthority: "प्राधिकरण को बाहर निकालने में प्रवेश करें",
        EnterShortName: "संक्षिप्त नाम दर्ज करें",
        EditFileClass: "फ़ाइल वर्ग संपादित करें",
        FileGroup: "फ़ाइल समूह",
        EnterFileGroupName: "फ़ाइल समूह का नाम दर्ज करें",
        FileGroupName: "फ़ाइल समूह का नाम",
        reqFileGroupName: "फ़ाइल समूह नाम की आवश्यकता है",
        FileSubject: "फ़ाइल विषय",
        EnterFileSubjectName: "फ़ाइल विषय नाम दर्ज करें",
        FileSubjectName: "फ़ाइल विषय का नाम",
        FileType: "फ़ाइल प्रकार",
        EnterFileTypeName: "फ़ाइल प्रकार का नाम दर्ज करें",
        FileTypeName: "फ़ाइल प्रकार का नाम",
        update: "अपडेट ",
        classDescription: "वर्ग विवरण",
        ReqclassDescription: "वर्ग विवरण की आवश्यकता है",
        LocationObjectItems: "स्थान ऑब्जेक्ट आइटम",
        Mapping: "प्रतिचित्रण",
        selectParntLoc: "पैरेंट स्थान का चयन करें",
        selectLoc: "स्थान का चयन करें",
        enterAddItem: "आइटम जोड़ें दर्ज करें",
        enterAlias: "उपनाम दर्ज करें",
        enterFrom: "से दर्ज करें",
        enterTo: "करने के लिए दर्ज करें",
        generate: "पैदा करना",
        LocationItem: "स्थान आइटम",
        MappedLocation: "मैप किया गया स्थान",
        Mapped: "प्रतिचित्रित ",
        Unmapped: "अमानचित्रित",
        reqdAlias: "उपनाम की आवश्यकता है",
        LocationName: "स्थान का नाम",
        selectAll: "सभी का चयन करें",
        UpdateMapped: "प्रतिचित्रित किया गया अपडेट",
        LocationPath: "स्थान पथ",
        Location: "स्थान",
        ReceiptStatus: "रसीद की स्थिति",
        RecStatus: "रसीद की स्थिति",
        EnterRecStatus: "रसीद की स्थिति दर्ज करें",
        ReceiptType: "रसीद का प्रकार",
        ReceiptName: "रसीद का नाम",
        EnterReceiptName: "रसीद का नाम दर्ज करें",
        FileCategory: "फ़ाइल श्रेणी",
        FileCatDescription: "फ़ाइल श्रेणी विवरण",
        FileCatDescRequired: "फ़ाइल श्रेणी विवरण आवश्यक है",
        CreateFileCategory: "फ़ाइल श्रेणी बनाएँ",
        EditFileCategory: "फ़ाइल श्रेणी संपादित करें",
        EnterFileCategory: "फ़ाइल श्रेणी दर्ज करें",
        JurisdictionName: "क्षेत्राधिकार का नाम",
        JurisdictionMaster: "क्षेत्राधिकार मास्टर",
        CreateJurisdictionMaster: "क्षेत्राधिकार मास्टर बनाएँ",
        EditJurisdictionMaster: "क्षेत्राधिकार मास्टर संपादित करें",
        EnterJurisdictionName: "क्षेत्राधिकार का नाम दर्ज करें",
        SelectNode: "नोड का चयन करें",
        RoleMaster: "रोल मास्टर",
        RoleName: "भूमिका का नाम",
        reqRoleName: "भूमिका का नाम आवश्यक है",
        enterRoleName: "भूमिका का नाम दर्ज करें",
        //  search: "ढूँढ",
        MenuName: "मेनू का नाम",
        Edit: "संपादन करना",
        delete: "मिटाना",
        View: "देखना",
        Print: "प्रिंट",
        Export: "निर्यातित माल",
        Release: "निर्गमन",
        Post: "के बाद",
        UserPermissionMaster: "उपयोगकर्ता अनुमति मास्टर",
        UserName: "उपयोगकर्ता का नाम",
        SelectEmployeeName: "कर्मचारी का नाम चुनें",
        ParentName: "जनक नाम",
        FileDetailsAddedSuccessFully: "फ़ाइल विवरण सफलतापूर्वक जोड़ा गया",
        FileDetailsUpdatedSuccessFully:
          "फ़ाइल विवरण सफलतापूर्वक अपडेट किया गया",
        LoginName: "लॉगिन नाम",
        Email: "ईमेल",
        Role: "भूमिका",
        UserManegment: "उपयोगकर्ता प्रबंधन",
        DOB: "जन्म तिथि",
        CreateUserManegment: "उपयोगकर्ता प्रबंधन बनाएँ",
        EnterFirstName: "पहला नाम दर्ज करें",
        EnterLastName: "अंतिम नाम दर्ज करें",
        EnterMiddleName: "मध्य नाम दर्ज करें",
        EnterLoginName: "लॉगिन नाम दर्ज करें",
        EnterPassword: "पासवर्ड दर्ज करें",
        EnterUserCode: "उपयोगकर्ता कोड दर्ज करें",
        EnterEmailId: "ईमेल आईडी दर्ज करें",
        EnterDateOfBirth: "जन्म तिथि दर्ज करें",
        reqFirst: "सबसे पहले नाम की आवश्यकता है",
        reqLast: "अंतिम नाम आवश्यक है",
        reqLogin: "लॉगिन नाम आवश्यक है",
        reqPassword: "पासवर्ड आवश्यक है",
        reqMobile: "मोबाइल नंबर आवश्यक है",
        reqEmail: "ईमेल की आवश्यकता है",
        reqDate: "जन्म तिथि आवश्यक है",
        SelectUserType: "उपयोगकर्ता प्रकार का चयन करें",
        SelectEmployee: "कर्मचारी का चयन करें",
        Name: "नाम",
        UserTypeMaster: "उपयोगकर्ता प्रकार मास्टर",
        EnterUserType: "उपयोगकर्ता प्रकार दर्ज करें",
        UserType: "उपयोगकर्ता का प्रकार",
        FileDetailsReport: "File Details Report",
        SelectFile: "फ़ाइल का चयन करें",
        Selectchack: "चक का चयन करें",
        Filter: "फ़िल्टर",
        Clear: "रीसेट करें ",
        FileDetailsReport: "फ़ाइल विवरण रिपोर्ट",
        FileMovementReport: "फ़ाइल मूवमेंट रिपोर्ट",
        Sender: "प्रेषक",
        Receiver: "रिसीवर",
        reqZoneName: "ज़ोन का नाम आवश्यक है",
        reqWard: "वार्ड का नाम आवश्यक है",
        reqstateName: "राज्य का नाम आवश्यक है",
        reqdistrictName: "जिले का नाम आवश्यक है",
        reqGenderName: "लिंग नाम की आवश्यकता है",
        reqFileSubjectName: "फ़ाइल विषय नाम की आवश्यकता है",
        reqFileTypeName: "फ़ाइल प्रकार की आवश्यकता है",
        reqRecStatus: "रसीद की स्थिति आवश्यक है",
        reqReceiptName: "रसीद नाम की आवश्यकता है",
        reqUserType: "उपयोगकर्ता प्रकार की आवश्यकता है",
        reqFileName: "फ़ाइल नाम आवश्यक है",
        reqchackNo: "चक नंबर की आवश्यकता है",
        SelectRFID: "आरएफआईडी का चयन करें",
        SelectFromLocation: "स्थान से चुनें",
        SelectToLocation: "स्थान के लिए चुनें",
        NodePermission: "नोड अनुमति",
        AddPermission: "अनुमति जोड़ें",
        SelectUser: "उपयोगकर्ता का चयन करें",
        NodeName: "नोड नाम",
        ReqFormAdd: "अनुरोध प्रपत्र जोड़ें",
        ReqFormEdit: "अनुरोध प्रपत्र संपादित करें",
        EnterReqDate: "अनुरोध तिथि दर्ज करें",
        EnterCustomerName: "ग्राहक का नाम दर्ज करें",
        MobileNO: "मोबाइल नंबर",
        HouseNO: "घर का नंबर",
        EnterAddress: "पता दर्ज करें",
        ReceiptDate: "प्राप्ति की तारीख",
        ReqFileStatus: "अनुरोध फ़ाइल स्थिति",
        chackNo: "चक नंबर",
        SelectchackNo: "चक नंबर चुनें",
        EditFileMovement: "फ़ाइल संचलन संपादित करें",
        RegistrarName: "रजिस्ट्रार का नाम",
        ProposalNo: "प्रस्ताव क्रमांक",
        ProposalDate: "प्रस्ताव दिनांक",
        NoticeManagement: "नोटिस प्रबंधन",
        add: "जोड़ें",
        edit: "संपादित करें",
        update: "अपडेट करें",
        reset: "रीसेट",
        save: "सहेजें",
        SrNo: "क्रमांक",
        Notice: "नोटिस",
        Description: "विवरण",
        NoticeDate: "नोटिस तिथि",
        FromDate: "प्रारंभ तिथि",
        ToDate: "समाप्ति तिथि",
        NoticeLink: "नोटिस लिंक",
        Status: "स्थिति",
        Active: "सक्रिय",
        InActive: "निष्क्रिय",
        Action: "कार्रवाई",
        CreateNotice: "नोटिस बनाएं",
        EditNotice: "नोटिस संपादित करें",
        NoticeTitle: "नोटिस शीर्षक",
        EnterNoticeTitle: "नोटिस शीर्षक दर्ज करें",
        EnterNoticeLink: "नोटिस लिंक दर्ज करें",
        EnterDescription: "विवरण दर्ज करें",
        UploadImage: "छवि अपलोड करें",
        PreviewImage: "छवि पूर्वावलोकन",
        noticeTitleRequired: "नोटिस शीर्षक आवश्यक है",
        descriptionRequired: "विवरण आवश्यक है",
        fromDateRequired: "प्रारंभ तिथि आवश्यक है",
        toDateRequired: "समाप्ति तिथि आवश्यक है",
        toDateAfterFromDate: "समाप्ति तिथि प्रारंभ तिथि के बाद होनी चाहिए",
        validUrl: "मान्य URL होना चाहिए",
        fileTooLarge: "फ़ाइल बहुत बड़ी (अधिकतम 5MB)",
        unsupportedFormat: "असमर्थित फ़ाइल प्रारूप (केवल jpg, png, gif अनुमत)",
        existingImage: "मौजूदा छवि",
        EnterOwnerName: "मालिक का नाम दर्ज करें",
        FileName: "फ़ाइल का नाम",
        FileDetails: "फ़ाइल विवरण",
        FileNo: "फ़ाइल नंबर",
        RFID: "आरएफआईडी",
        BasicInformation: "मूल जानकारी",
        FileType: "फ़ाइल प्रकार",
        FileGroup: "फ़ाइल समूह",
        Category: "श्रेणी",
        Class: "वर्ग",
        Subject: "विषय",
        chackNo: "चक नंबर",
        TotalPages: "कुल पृष्ठ",
        PagesRange: "पृष्ठ सीमा",
        StatusLocation: "स्थिति और स्थान",
        Status: "स्थिति",
        Received: "प्राप्त",
        Pending: "लंबित",
        Forwarded: "अग्रेषित",
        NA: "उपलब्ध नहीं",
        CurrentLocation: "वर्तमान स्थान",
        Zone: "क्षेत्र",
        Ward: "वार्ड",
        Registrar: "रजिस्ट्रार",
        DatesTracking: "तिथियाँ और ट्रैकिंग",
        CreatedDate: "निर्माण तिथि",
        UpdatedDate: "अद्यतन तिथि",
        ProposalNo: "प्रस्ताव संख्या",
        ProposalDate: "प्रस्ताव तिथि",
        AdditionalInformation: "अतिरिक्त जानकारी",
        Synopsis: "सारांश",
        Remark: "टिप्पणी",
        NoRemarksProvided: "कोई टिप्पणी नहीं दी गई",
        Close: "बंद करें",
        Pleaseapplyfiltersandclicksearchtoviewdata:
          "कृपया डेटा देखने के लिए फ़िल्टर लागू करें और खोज पर क्लिक करें",
        Nodatafoundfortheselectedfilters:
          "चयनित फ़िल्टर के लिए कोई डेटा नहीं मिला",
        FileMovementDetails: "फ़ाइल स्थानांतरण विवरण",
        FileName: "फ़ाइल का नाम",
        FileNumber: "फ़ाइल नंबर",
        NA: "उपलब्ध नहीं",
        TransferDetails: "स्थानांतरण विवरण",
        FromLocation: "स्थान से",
        ToLocation: "स्थान पर",
        NotSpecified: "निर्दिष्ट नहीं",
        Through: "के माध्यम से",
        DirectTransfer: "सीधा स्थानांतरण",
        Personnel: "कर्मचारी",
        Sender: "प्रेषक",
        Receiver: "प्राप्तकर्ता",
        InitiatedBy: "द्वारा शुरू किया गया",
        System: "सिस्टम",
        Timeline: "समयरेखा",
        FileDate: "फ़ाइल तिथि",
        CreatedDate: "निर्माण तिथि",
        ReceivedDate: "प्राप्ति तिथि",
        TransferDate: "स्थानांतरण तिथि",
        NotTransferredYet: "अभी तक स्थानांतरित नहीं",
        Close: "बंद करें",

        AuditTrailDetail: "ऑडिट ट्रेल विवरण",
        FileName: "फ़ाइल का नाम",
        FileNumber: "फ़ाइल नंबर",
        NA: "उपलब्ध नहीं",
        TransferDetails: "स्थानांतरण विवरण",
        FromLocation: "स्थान से",
        ToLocation: "स्थान पर",
        NotSpecified: "निर्दिष्ट नहीं",
        Through: "के माध्यम से",
        DirectTransfer: "सीधा स्थानांतरण",
        Personnel: "कर्मचारी",
        Sender: "प्रेषक",
        Receiver: "प्राप्तकर्ता",
        InitiatedBy: "द्वारा शुरू किया गया",
        System: "सिस्टम",
        Timeline: "समयरेखा",
        FileDate: "फ़ाइल तिथि",
        CreatedDate: "निर्माण तिथि",
        ReceivedDate: "प्राप्ति तिथि",
        TransferDate: "स्थानांतरण तिथि",
        NotTransferredYet: "अभी तक स्थानांतरित नहीं",
        Close: "बंद करें",
        AuditTrailReport: "ऑडिट ट्रेल रिपोर्ट",
        AssignedFiles: "असाइन की गई फ़ाइलें",
        CreatedFiles: "बनाई गई फ़ाइलें",
        Excel: "एक्सेल",
        PDF: "पीडीएफ",
        FailedToFetchPendingData: "लंबित डेटा प्राप्त करने में विफल",
        AnUnknownErrorOccurred: "एक अज्ञात त्रुटि हुई",
        FileNo: "फाइल नंबर",
        FileName: "फाइल का नाम",
        Synopsis: "सारांश",
        RFID: "आरएफआईडी",
        ChackNo: "चैक नंबर",
        CurrentLocation: "वर्तमान स्थान",
        PendingEPCData: "लंबित ईपीसी डेटा",
        HideFilters: "फिल्टर छिपाएं",
        ShowFilters: "फिल्टर दिखाएं",
        Zone: "क्षेत्र",
        Ward: "वार्ड",
        Reset: "रीसेट",
        Close: "बंद करें",
        ApprovedEPCData: "अनुमोदित ईपीसी डेटा",
        TotalEPCData: "कुल ईपीसी डेटा",
        WardDetails: "वार्ड विवरण",
        WardName: "वार्ड का नाम",
        FileCount: "फ़ाइल संख्या",
        files: "फ़ाइलें",
        SelectWardName: "वार्ड का नाम चुनें",
        EnterChackNo: "चेक नंबर दर्ज करें",
        reqChackNo: "चेक नंबर आवश्यक है",
        SelectStatus: "स्थिति चुनें",
        SelectChackNo: "चाक नंबर चुनें",
        ChakNo: "चाक नंबर",
        MenuMaster: "मेनू मास्टर",
        PageURL: "पेज यूआरएल",
        Icon: "आइकन",
        saving: "सहेजा जा रहा है",
        reqfileNo: "फ़ाइल नंबर आवश्यक है",
        reqJurisdiction: "क्षेत्राधिकार आवश्यक है",
        SelectLocation: "स्थान चुनें",
        NoFileContentAvailable: "फ़ाइल सामग्री उपलब्ध नहीं है",
        PreviewFile: "फ़ाइल पूर्वावलोकन",
        NoDataToExport: "निर्यात करने के लिए कोई डेटा नहीं है",
        PDFPreview: "पीडीएफ पूर्वावलोकन",
        Cancel: "रद्द करें",
        Download: "डाउनलोड करें",
        UploadFile: "फ़ाइल अपलोड करें",
        reqUser: "उपयोगकर्ता आवश्यक है",
        reqGender: "लिंग आवश्यक है",
        reqcountryName: "देश आवश्यक है",
        zoneName: "ज़ोन नाम",
        reqMenuName: "मेनू नाम आवश्यक है",
        CreateMenuMaster: "मेनू मास्टर बनाएँ",
        EditMenuMaster: "मेनू मास्टर संपादित करें",
        EnterMenuName: "मेनू नाम दर्ज करें",
        EnterPageURL: "पेज URL दर्ज करें",
        EnterIcon: "आइकन दर्ज करें",
        selectParentMenuName: "पेरेंट मेनू नाम चुनें",
        EnterdisplayNo: "डिस्प्ले नंबर दर्ज करें",
        FileTransferHistory: "फ़ाइल स्थानांतरण",
        Transfer: "स्थानांतरण",
      },
      content: {},
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage || "en",
  // lng: 'hi',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
